var _excluded = ["className", "isFlushPadding", "children", "hasBorder", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledModalFooterInner from './styles/modal.footer.inner.styles';
import StyledModalFooter from './modal.footer.styles';
var modalFooterPropTypes = {
  /** Child elements to be rendered inside of the modal footer */
  children: PropTypes.node,
  /** Add custom CSS classes to component */
  className: PropTypes.string,
  /** To remove the left and right padding */
  isFlushPadding: PropTypes.bool,
  /** Adds a border to the top of the footer */
  hasBorder: PropTypes.bool,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var modalFooterDefaultProps = {
  className: '',
  children: /*#__PURE__*/React.createElement("div", null),
  isFlushPadding: false,
  hasBorder: true,
  utils: {}
};
var ModalFooter = function ModalFooter(props) {
  var className = props.className,
    isFlushPadding = props.isFlushPadding,
    children = props.children,
    hasBorder = props.hasBorder,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledModalFooter, _extends({}, other, {
    className: className,
    hasBorder: hasBorder,
    isFlushPadding: isFlushPadding,
    utils: utils
  }), /*#__PURE__*/React.createElement(StyledModalFooterInner, null, children));
};
ModalFooter.propTypes = modalFooterPropTypes;
ModalFooter.defaultProps = modalFooterDefaultProps;
ModalFooter.displayName = 'Modal.Footer';
export default ModalFooter;